// @flow

// Effect Managers
import { call, select } from 'redux-saga/effects'

// Selectors
import token$ from '../selectors/token'

// Storage
import storage from 'fc-storage'

// Exports
export default function *getDomToken (): Generator<*, ?string, ?string> {
  const token: ?string = yield select(token$)
  if (token) {
    return token
  }

  try {
    if (window && window.location && window.location.search) {
      const match = window.location.search.match(/token=([A-Z,a-z,0-9]*)$/)

      if (match && match.length === 2) {
        return match[1]
      }
    }
  } catch (error) {

  }

  return yield call([storage, storage.getItem], 'token')
}
